module.exports = __webpack_public_path__ + "static/media/preguntas.ba3e6ef6.svg";